import React from 'react';
import * as S from './styles';

function DataPDF(){

    const data = new Date();

    const meses = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ];

    const mes = meses[data.getMonth()];
    const ano = data.getFullYear();

    return(<S.TextFooter>{mes}/{ano}</S.TextFooter>);
};

export default DataPDF;